<!--
 * @description: 
 * @author: Jason Wong
 * @since: 2021-12-14 13:38:29
-->
<script>
import { isAncestorOf } from "../../utils/domHelper";
import Nav from "./nav.vue";

export default {
  name: "VERibbonTable",
  props: {
    value: {
      type: String,
    },
    hideNavWhenPanelLessThenTwo: {
      type: Boolean,
      default: false,
    },
    timeTip:{
      type: String,
    },
    isSaving:{
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      panels: [],
      currentPanel: this.value,
      isExpand: true,
    };
  },
  methods: {
    getPanels() {
      if (this.$slots.default) {
        const paneSlots = this.$slots.default.filter(
          (vnode) =>
            vnode.tag &&
            vnode.componentOptions &&
            vnode.componentOptions.Ctor.options.name === "VERibbonPanel"
        );
        const panels = paneSlots.map(
          ({ componentInstance }) => componentInstance
        );
        if (panels.length != this.panels.length) {
          this.panels = panels;
        }
      } else {
        this.panels = [];
      }
    },
    setCurrentPanel(panelName) {
      this.currentPanel = panelName;
      this.$emit("input", this.currentPanel);
    },
  },
  watch: {
    value(newValue) {
      this.setCurrentPanel(newValue);
    },
  },
  render(h) {
    return h("div", { class: "component--ribbon" }, [
      h(Nav, {
        class: "section__nav",
        style: {
          display: this.shouldNavBarHidden ? "none" : null,
        },
        props: {
          panels: this.panels,
          value: this.currentPanel,
        },
        on: {
          input: (tabName) => {
            this.setCurrentPanel(tabName);
          },
          "tab-click": (tabName) => {
            if (!this.isExpand) {
              this.isExpand = true;
            }
          },
        },
      }),
      h(
        "div",
        {
          class: ["section__body", !this.isExpand ? "force-toggled" : null],
          ref: "body",
        },
        [
          h(
            "div",
            {
              class: "section__panel-container",
            },
            this.$slots.default
          ),
        ]
      ),
      h(
        "div",
        {
          class: ["section__tips",],
          ref: "body",
        },
        [
          h(
            "div",
            {
              class: "section__tips-container",
              style: {
                display: this.timeTip ? null : "none",
              },
            },
            [
              h("i", {
                  class: this.isSaving ? "el-icon-loading" : "el-icon-circle-check",
              }),
              h("span", {
                  class: "tip-div",
              },
              this.timeTip,
              ),
            ]
          ),
        ]
      ),
      
      h(
        "div",
        {
          class: "button__switch-state",
          attrs: {
            title: !this.isExpand ? "展开" : "收缩",
          },
          style: {
            display: this.shouldNavBarHidden ? "none" : null,
          },
          on: {
            click: () => {
              this.isExpand = !this.isExpand;
            },
          },
        },
        [
          h("fa-icon", {
            props: {
              icon: !this.isExpand ? "angle-right" : "angle-left",
            },
          }),
        ]
      ),
    ]);
  },
  computed: {
    shouldNavBarHidden() {
      return (this.panels || []).length < 2 && this.hideNavWhenPanelLessThenTwo;
    },
  },
  mounted() {
    this.getPanels();
  },
  updated() {
    this.getPanels();
  },
  destroyed() {},
};
</script>

<style lang="scss">
.component--ribbon {
  width: 100%;

  .section__nav {
    border-bottom: 1px solid #d5d6d9;
  }
  .section__body {
    position: relative;
    border-bottom: 1px solid #dbdee4;
    width: 100%;
    height: 90px;

    .section__panel-container {
      width: 100%;
      height: 100%;
    }

    &.force-toggled {
      height: 0 !important;
      overflow: hidden;
    }
  }
  .button__switch-state {
    position: absolute;
    cursor: pointer;
    color: #909c99;
    right: 10px;
    top: 6px;
    transform: rotate(90deg);

    &:hover {
      opacity: 0.7;
    }
  }
  .section__tips{
    position: absolute;
    left: 70px;
    top: 4px;
    color: #909399;
    .tip-div{
      margin-left: 3px;
      font-size: 14px;
      color: #909399;
    }
  }
}
</style>